export default {
  allMsg: 'Wszystkie wiadomości',
  systemMsg: 'Wiadomości systemowe',
  personMsg: 'Wiadomości ręczne',
  unread: 'Nieprzeczytane',
  seeDetail: 'Zobacz szczegóły',
  read: 'Przeczytane',
  replyNow: 'odpowiedz teraz',
  message: 'Wiadomość',
  operateSuccess: 'Operacja zakończona pomyślnie',
  holder: {
    searchHolder: 'Nr paczki/Nr zamówienia/Nr przedmiotu',
  },
  addAcBuy: 'Dołącz do Discorda AcBuy i wygraj ¥2000 w gotówce! ',
  joinNow: 'Dołącz tutaj',
  flatActivity: 'Wyprzedaż Black Friday w Acbuy',
  joinNow1: 'Dołącz teraz',
  tips1: 'Skorzystaj ze zniżki do 70%',
  tips2: 'Wprowadź kod, aby natychmiast otrzymać kupon na przesyłkę o wartości ¥110!',
}
